import { c as _c } from "react/compiler-runtime";
import CommonDropdown from "@/components/utils/select/dropdown/CommonDropdown";
import { CommonSelectItem } from "@/components/utils/select/CommonSelect";
import { CollectedCollectionType } from "@/entities/IProfile";
import { COLLECTED_COLLECTIONS_META } from "./user-page-collected-filters.helpers";
type SelectedType = CollectedCollectionType | null;
export default function UserPageCollectedFiltersNativeDropdown(t0) {
  const $ = _c(4);
  const {
    selected,
    setSelected
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [{
      label: "All",
      mobileLabel: "All Collections",
      value: null,
      key: "all"
    }, ...Object.values(CollectedCollectionType).filter(_temp).map(_temp2)];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const items = t1;
  let t2;
  if ($[1] !== selected || $[2] !== setSelected) {
    t2 = <CommonDropdown items={items} activeItem={selected} filterLabel="Collection" setSelected={setSelected} />;
    $[1] = selected;
    $[2] = setSelected;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp2(collection_0) {
  return {
    label: COLLECTED_COLLECTIONS_META[collection_0].label,
    value: collection_0,
    key: collection_0
  };
}
function _temp(collection) {
  return collection !== CollectedCollectionType.NETWORK;
}